import { atom } from 'jotai';
import { ProjectKey } from '@/config/projects';

// Estado del proyecto actual
export const currentProjectAtom = atom<ProjectKey>('3m');

// Estado del project_id numérico (para RLS)
export const currentProjectIdAtom = atom<number>(1);

// Atom derivado que actualiza el project_id cuando cambia el proyecto
export const updateProjectIdAtom = atom(
  null,
  (get, set, project: ProjectKey) => {
    const projectIdMap: Record<ProjectKey, number> = {
      '3m': 1,
      'es': 2
    };
    
    set(currentProjectAtom, project);
    set(currentProjectIdAtom, projectIdMap[project]);
  }
);
